import { MicrophoneSelection } from "@/components/MicrophoneSelection";
import { RecordingLanguageSelect } from "@/components/RecordingLanguageSelect";
import { usePrepareRecording } from "@/contexts/PrepareRecording/usePrepareRecording";
import { BatteryFullIcon, Color, HorizontalFlex, IconSize, MediumTextM, Space, VerticalFlex, VolumeOffIcon, WifiOnIcon } from "@enxcs/dap-ui-stratos";
import { useTranslation } from "react-i18next";

export const BeforeRecordingContent = () => {
  const { t } = useTranslation();
  const selectedLanguage = usePrepareRecording((state) => state.selectedLanguage);
  const setSelectedLanguage = usePrepareRecording((state) => state.setSelectedLanguage);
  const setSelectedAudioType = usePrepareRecording((state) => state.setSelectedAudioType);
  const onMicrophoneStatusChange = usePrepareRecording((state) => state.onMicrophoneStatusChange);

  return (
    <VerticalFlex $gap={Space.V16}>
      <MediumTextM>
        {t("newRecordingModal.checkInternet")}

        <HorizontalFlex $justify={"flex-start"} $gap={Space.V16}>
          <WifiOnIcon size={IconSize.V18} tone={Color.Neutral.V70} />
          <VolumeOffIcon size={IconSize.V18} tone={Color.Neutral.V70} />
          <BatteryFullIcon size={IconSize.V18} tone={Color.Neutral.V70} />
        </HorizontalFlex>
      </MediumTextM>
      <MediumTextM>{t("newRecordingModal.legalNotice")}</MediumTextM>
      <RecordingLanguageSelect value={selectedLanguage} onChange={setSelectedLanguage} />

      <VerticalFlex $gap={Space.V8}>
        <MicrophoneSelection setSelectValueAudioType={setSelectedAudioType} defaultSelected="default" onMicrophoneStatusChange={onMicrophoneStatusChange} />
      </VerticalFlex>
    </VerticalFlex>
  );
};
